import {
  primeExtensionCredentials,
  primeVideoTargetReliable,
  serializeExtensionOpen,
  isExtensionInstalled,
} from './instatExtension';

// Open the Hudl Instat player page so the user can pick any clip (match,
// skill, stat playlist) and save it back tagged with the given informe id.
// Different from instatVideo.js: there is no backend round-trip to resolve a
// playlist link — the user navigates Hudl freely. The extension stays primed
// with informeId for the next 5 minutes (TARGET_TTL_MS in background.js).

function openLoadingPopup(title) {
  const popup = window.open('about:blank', '_blank');
  if (!popup) return null;
  try {
    popup.document.title = title || 'Hudl…';
    popup.document.body.style.cssText =
      'margin:0;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Display","Inter",sans-serif;color:#1D1D1F;background:#F5F5F7;';
    popup.document.body.innerHTML = `
      <div style="max-width:460px;margin:8rem auto;padding:2.5rem;background:#fff;border-radius:20px;box-shadow:0 1px 2px rgba(17,24,39,.04),0 8px 24px rgba(17,24,39,.05);text-align:center">
        <div style="width:44px;height:44px;margin:0 auto 1.25rem;border:3px solid rgba(0,0,0,.08);border-top-color:#007AFF;border-radius:50%;animation:spin .9s cubic-bezier(.25,.1,.25,1) infinite"></div>
        <div style="font-size:18px;font-weight:600;letter-spacing:-.01em;margin-bottom:.35rem">Hudl Instat</div>
        <div style="font-size:13.5px;color:#86868B">${title || ''}</div>
      </div>
      <style>@keyframes spin{to{transform:rotate(360deg)}}</style>`;
  } catch {
    /* some browsers block document.write on about:blank */
  }
  return popup;
}

// Open the Hudl player page and prime the extension so subsequent clip saves
// are tagged with informeId.
export async function openHudlPlayerForInforme({
  instatPlayerId,
  localPlayerId = null,
  informeId,
  informeTitle = '',
}) {
  if (!instatPlayerId) {
    alert('Ce joueur n’a pas d’id Instat — impossible d’ouvrir Hudl.');
    return;
  }
  const popup = openLoadingPopup(informeTitle);
  if (!popup) {
    alert('Le navigateur a bloqué le pop-up. Autorise les pop-ups sur cette page puis réessaie.');
    return;
  }

  const targetUrl = `https://app.hudl.com/instat/basketball/players/${instatPlayerId}`;
  // Sérialisé via le même verrou que instatVideo.js : la cible (instatTarget) est
  // globale à l'extension, donc une ouverture informe et une ouverture vidéo ne
  // doivent pas primer leur cible en même temps.
  return serializeExtensionOpen(async () => {
    // Prime credentials so autologin works if the popup lands on Hudl's login.
    primeExtensionCredentials().catch(() => null);
    if (isExtensionInstalled()) {
      await primeVideoTargetReliable(targetUrl, {
        localPlayerId,
        instatPlayerId,
        informeId,
      });
    }
    popup.location = targetUrl;
  });
}
